// extracted by css-extract-rspack-plugin
export default {"wrapper":"_269d4b0e","isDibsPromiseVariant":"_890f1493","columnOverride":"_c80dbddf","circle":"_218b154f"};